'use client'
import { Figure } from '@/components/base/Figure'
import { SliderFlickity } from '@/components/base/SliderFlickity'
import { vw, mq } from '@/styles'
import { memo, useMemo } from 'react'
import styled from 'styled-components'
import { motion } from 'motion/react'
import { TypeCmsMediumImage } from '@/schema'

// PENDING FIX, PROBABLY WILL BE UPDATED/REMOVED
interface IContentSlideShow {
  data: {
		media: {
			slideshow: TypeCmsMediumImage[]
		}
	}
}

const getSlides = (media) => media.map((item, idx) =>{
  return (
    <motion.div key={idx} >
      <Figure media={item.image}/>
    </motion.div>
  )
})


export const ContentSlideShow = memo(({ data }: IContentSlideShow) => {
  const { media:{ slideshow} } = data
  const Slides = useMemo(() => getSlides(slideshow), [slideshow])

  return (
    <Div>
      <SliderFlickity className={'slider__images'} hasCustomDots={slideshow.length > 1} colorDots={'#3C3C3B'} options={{
        contain: false,
        wrapAround: true,
        initialIndex: 0,
        freeScroll: false,
        cellAlign: 'center',
        draggable: false,
        accessibility: true,
        autoPlay: 5000,
        pauseAutoPlayOnHover: false
      }}>
        {Slides}
      </SliderFlickity>
    </Div>
  )
})

const Div = styled.div`
  margin: 0;
  overflow: hidden;
  width: 100%;

  &,
  .slider-wrapper {
    height: ${vw(200, 'mobile')};
    position: relative;

    ${mq.greaterThan('tablet')} {
      height: ${vw(700, 'desktop')};
    }

  }
  > div {
    grid-column: 1 / span 6;
    overflow: hidden;
    width: 100%;

    ${mq.greaterThan('tablet')} {
      grid-column: 1 / span 12;
    }

    .slider__images,
      figure {
        height: ${vw(200, 'mobile')};

        ${mq.greaterThan('tablet')} {
          height: ${vw(600, 'desktop')};
        }
      }

    .flickity-cell {
      width: ${vw(370, 'mobile')};

        ${mq.greaterThan('tablet')} {
        width: ${vw(1380, 'desktop')};
      }
    }

    .flickity-page-dots {
      display: none;
    }



    .custom-dots {
      bottom: 0;
      display: flex;
      gap: 10px;
      justify-content:center;
      margin: 0 auto;
      max-width: 640px;
      position: absolute;
      right: 50%;
      transform: translateX(50%);
      width: 100%;
      z-index: 2;

      ${mq.greaterThan('tablet')} {
        bottom: ${vw(30, 'desktop')};
      }

    }


  }


`
